export default "__VITE_ASSET__DmDmMLhd__"